import { useTranslations } from "next-intl";
import { Link } from "@components/core";

function ClosetActionPostReturned({ closet }) {
  const t = useTranslations("closets");

  return (
    <div className="pb-3">
      {closet?.return_follow_up_url && (
        <Link
          className="link-primary"
          noUnderline
          href={closet?.return_follow_up_url}
          target="_blank"
          rel="noreferrer"
        >
          {t("state.post_returned.closet_action_button_title")}
        </Link>
      )}
    </div>
  );
};

export default ClosetActionPostReturned;
